// Components
import TiptapTextStyleTool from './TiptapTextStyleTool';

// Styles
import './TextStyleTool.scss';

export default TiptapTextStyleTool;
